import { Avatar, Badge, Select, Spin, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { getCachedGuests } from 'services/guests.services';

import "./GuestDropdown.scss"
import { CloseCircleOutlined, FlagFilled, LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { ReactComponent as SearchIco } from "assets/icons/searchIco.svg";

const PAGE_SIZE = 10;
const Option = Select.Option;

export default function GuestDropdown({
    value,
    onChange,
    placeholder = "Select",
    isAddressPrimary,
    disableGuestId
}) {

    const abortConRef = useRef();
    const dispatch = useDispatch()

    const [guestSearch, setGuestSearch] = useState("");
    const [guests, setGuests] = useState({
        data: [],
        isLoading: true,
        totalRecords: 0,
        currentPage: 1,
    });

    // functions start
    const getData = (page, sortBy, ascend, searchText, active) => {
        console.log('getData called', page, searchText)
        setGuests((state) => ({
            ...state,
            isLoading: true,
        }));


        console.log('wtf', abortConRef.current?.signal?.aborted)
        if (abortConRef.current && abortConRef.current.signal.aborted === false) abortConRef.current.abort();
        abortConRef.current = new AbortController();
        console.log('new abort?', abortConRef.current)


        dispatch(
            getCachedGuests(
                (page - 1) * PAGE_SIZE,
                PAGE_SIZE,
                sortBy,
                ascend,
                searchText,
                null,
                abortConRef?.current?.signal,
                false
            )
        )
            .then((res) => {
                if (res?.status === "success") {
                    console.log('success')
                    setGuests((state) => ({
                        ...state,
                        data: page > 1 ? [...state.data, ...res.data] : res?.data,
                        totalRecords: res?.totalRecords,
                        currentPage: page,
                        isLoading: false,
                    }));
                } else {
                    if (res !== "aborted")
                        setGuests(state => ({
                            ...state,
                            isLoading: false
                        }))
                }
            })
            .finally(() => {
                console.log('finally')

                // setGuests(state=>({
                //     ...state,
                //     isLoading: false
                // }))
            })

    };
    // functions end


    // useEffects Start
    useEffect(() => {
        getData(1, "FirstName", true, guestSearch, true);
    }, [guestSearch]); //eslint-disable-line


    return (
        <Select
            autoClearSearchValue={false}
            className='guestDropdown'
            isSearch={true}
            allowClear
            value={value}
            onChange={onChange}
            bordered={true} style={{
                width: 240,
                padding: 4,
                borderRadius: 6,
                border: '2px solid #d8dce4',
                boxShadow: 'none'
            }}
            notFoundContent={
                guests.isLoading ? <>Searching</> : <>No Data Found</>
            }
            placeholder={placeholder}
            showSearch={true}
            searchValue={guestSearch}
            onSearch={(value) => {
                console.log('value', value)
                setGuestSearch(value);
            }}
            filterOption={(input, option) => {
                const fullName = option.title.toLowerCase();
                const searchValue = input.toLowerCase();
                return fullName.includes(searchValue);
            }}
            suffixIcon={
                guests.isLoading ? <Spin
                    indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                />
                    : <SearchIco
                    />
            }
            optionLabelProp="title"

            loading={guests.isLoading}
            onPopupScroll={(event) => {
                const target = event.target;
                if (
                    target.scrollTop + target.clientHeight ===
                    target.scrollHeight
                ) {
                    getData(
                        guests.currentPage + 1,
                        "FirstName",
                        true,
                        guestSearch,
                        true
                    );
                }
            }}
        >
            {
                guests.data.map((guest) => {
                    const isFlagged = guest.isCustomerProfileFlagged
                    const isDisabled = disableGuestId === guest.customerId
                    return <Option
                        key={guest.customerId}
                        value={guest.customerId}
                        title={guest.firstName + " " + guest.lastName}
                        disabled={isDisabled}
                    >
                        <div style={{
                            color: guest.isCustomerProfileFlagged ? 'red' : '#000',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            // background: isDisabled ? "#f1f1f1" :"#fff",
                            opacity: isDisabled ? 0.5 : 1
                        }}>
                            <Tooltip title={isFlagged ? "Profile is flagged" : null}>
                                <Badge
                                    offset={[-5, 5]}
                                    count={
                                        isFlagged ? (
                                            <FlagFilled style={{ color: "#f5222d" }} />
                                        ) : (
                                            0
                                        )
                                    }
                                >
                                    <Avatar
                                        icon={<UserOutlined />}
                                        style={{ marginRight: 6, }}
                                    />
                                </Badge>
                            </Tooltip>


                            {guest.firstName + " " + guest.lastName}

                            {!guest.isActive && <>
                                <Tooltip title={isFlagged ? "Profile is inactive" : null}>
                                    <CloseCircleOutlined style={{
                                        color: 'red'
                                    }} />
                                </Tooltip>
                            </>}
                        </div>
                    </Option>
                })
            }
            {/* options={guests.data.map(guest => ({
                value: guest.customerId,
                label: guest.firstName + " " + guest.lastName,
                disabled: disableGuestId === guest.customerId
            }))} */}
        </Select>
    )
}
